import { Box, Text } from "@chakra-ui/react";
import { DonutChart } from "./index";
import { useTranslation } from "react-i18next";

function ProductReport({ data, containerFlow }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "supplierDashboard.charts"
  });

  const getDonutChartData = () => {
    return [
      {
        id: 1,
        value: data,
        label: "Product Total Emissions",
        "color": "hsl(20, 70%, 50%)"
      }
    ];
  };

  return (
    <Box paddingInlineStart={containerFlow === "row" ? 2 : 0}>
      <Text fontSize="xl" fontWeight="600">
        {t("product")} {t("emissionsDataOverview")}
      </Text>
      <Box height={"300px"}>
        <DonutChart data={getDonutChartData()} />
      </Box>
    </Box>
  );
}

export default ProductReport;